import BaseContainer from '@base/BaseContainer';
import Footer from './Footer';
import Header from './Header';

import { ILayoutProps } from './default';

const LightLayout: React.FC<ILayoutProps> = ({ children, isAuth }) => {
    return (
        <div className="flex flex-col min-h-[100vh]">
            <Header isAuth={isAuth} />
            <div className="flex-grow mt-4 mb-4 xs:mt-10 xs:mb-10">
                <BaseContainer>{children}</BaseContainer>
            </div>
            <Footer isAuth={isAuth} />
        </div>
    );
};

export default LightLayout;
